export default {
  disasterAuthorization: {
    title: 'Autorização',
    text: 'Favor selecione seu provedor de dados e digite a chave correspondente do seu usuário HeiGIT Disaster Portal. Se você ainda não tem um usuário, solicite um enviando um e-mail para support[at]openrouteservice.heigit.org, especificando seu caso de uso. Mesmo sem uma chave, o aplicativo pode ser usado no modo somente leitura.',
    save: 'Enviar',
    enterTheAuthorizationKey: 'Insira a chave aqui',
    selectProvider: 'Selecione seu provedor de dados',
    useReadOnly: 'Usar no modo leitura',
    authenticateAsAdmin: 'Ative o modo de administração aqui',
    insertAValidKey: 'Uma chave válida deve ser inserida',
    insertAProvider: 'Um provedor de dados correspondente à sua autorização deve ser escolhido'
  }
}
